(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('collection-description')) {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-collection-description-content]');
        this.toggle = this.querySelector('[data-collection-description-toggle]');
        this.toggleText = this.querySelector('[data-collection-description-toggle-text]');
        this.expanded = false;

        if (!this.content || !this.toggle || !this.toggleText) return;

        this.toggle.addEventListener('click', this.toggleDescription);
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.content);
        this.refresh();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.toggleDescription);
        this.resizeObserver?.disconnect();
      }

      refresh = () => {
        const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight) || 24;
        this.collapsedHeight = Math.ceil(lineHeight * 3) + 6;
        const fullHeight = this.content.scrollHeight;

        if (fullHeight <= this.collapsedHeight + 2) {
          this.toggle.hidden = true;
          this.content.style.setProperty('--collection-description-height', 'none');
          return;
        }

        this.toggle.hidden = false;
        this.content.style.setProperty(
          '--collection-description-height',
          this.expanded ? `${fullHeight}px` : `${this.collapsedHeight}px`
        );
      };

      toggleDescription = () => {
        this.expanded = !this.expanded;
        this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
        this.toggleText.textContent = this.expanded ? this.toggle.dataset.viewLess : this.toggle.dataset.readMore;
        this.toggleAttribute('expanded', this.expanded);
        this.content.style.setProperty(
          '--collection-description-height',
          this.expanded ? `${this.content.scrollHeight}px` : `${this.collapsedHeight}px`
        );
      };
    }

    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  if (!customElements.get('cart-drawer-upsell-carousel')) {
    class CartDrawerUpsellCarousel extends HTMLElement {
      connectedCallback() {
        const drawer = this.closest('cart-drawer');
        this.previousButton = drawer?.querySelector('[data-upsell-previous]');
        this.nextButton = drawer?.querySelector('[data-upsell-next]');
        this.previousButton?.addEventListener('click', this.previous);
        this.nextButton?.addEventListener('click', this.next);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.previous);
        this.nextButton?.removeEventListener('click', this.next);
      }

      previous = () => this.scrollByCard(-1);
      next = () => this.scrollByCard(1);

      scrollByCard(direction) {
        const card = this.querySelector('[data-upsell-card]');
        if (!card) return;
        const isMobile = window.matchMedia('(max-width: 740px)').matches;
        const cardStyles = getComputedStyle(card);

        if (isMobile) {
          const gap = parseFloat(getComputedStyle(this).columnGap) || parseFloat(cardStyles.marginInlineEnd) || 0;
          this.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        } else {
          const gap = parseFloat(cardStyles.marginBottom) || 0;
          this.scrollBy({ top: direction * (card.offsetHeight + gap), behavior: 'smooth' });
        }
      }
    }
    customElements.define('cart-drawer-upsell-carousel', CartDrawerUpsellCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
